export function Asterisk() {
  return (
    <span
      style={{
        color: "var(--ion-color-danger)",
        fontSize: "var(--swing-font-lg)",
        fontWeight: "var(--swing-font-medium)",
      }}
    >
      {" "}
      *
    </span>
  );
}
